import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { btnPrimary, inputCls, Panel } from "../ui";

const TYPES = [["carico", "Carico"], ["scarico", "Scarico"], ["rettifica", "Rettifica (imposta quantità)"], ["reso", "Reso"]];

export const InventoryPanel = ({ product, onChange }) => {
  const [moves, setMoves] = useState([]);
  const [form, setForm] = useState({ type: "carico", qty: 1, note: "" });
  const [stats, setStats] = useState(product);
  const load = () => api.get(`/admin/products/${product.id}/movements`).then((r) => setMoves(r.data));
  useEffect(() => { load(); }, [product.id]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { setStats(product); }, [product]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post(`/admin/products/${product.id}/movements`, { ...form, qty: Number(form.qty) });
      setStats((s) => ({ ...s, stock: data.stock_after, sold: (s.sold || 0) + (form.type === "scarico" ? data.qty : form.type === "reso" ? -data.qty : 0) }));
      onChange(data.stock_after); load(); setForm({ ...form, note: "" });
      toast.success("Movimento registrato");
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <Panel title="Magazzino" testId="inventory-panel">
      <div className="grid grid-cols-4 gap-2 text-center mb-5">
        {[["Disponibili", stats.stock, "inv-stock"], ["Riservati", stats.reserved || 0, "inv-reserved"], ["Venduti", stats.sold || 0, "inv-sold"], ["Soglia", stats.min_stock ?? 1, "inv-min"]].map(([l, v, id]) => (
          <div key={id} className="bg-[#F5F0E8] border border-[#D5B98C]/50 py-3">
            <div data-testid={id} className="font-serif text-3xl text-[#39251D]">{v}</div>
            <div className="text-[10px] uppercase tracking-widest text-[#956842]">{l}</div>
          </div>
        ))}
      </div>
      <form onSubmit={submit} className="grid grid-cols-2 sm:grid-cols-[1.4fr_0.6fr_1.4fr_auto] gap-2">
        <select data-testid="inv-type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className={inputCls}>{TYPES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        <input data-testid="inv-qty" type="number" min="0" value={form.qty} onChange={(e) => setForm({ ...form, qty: e.target.value })} className={inputCls} />
        <input data-testid="inv-note" placeholder="Nota" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} className={`${inputCls} col-span-2 sm:col-span-1`} />
        <button data-testid="inv-submit" className={`${btnPrimary} col-span-2 sm:col-span-1`}>Registra</button>
      </form>
      <ul className="mt-5 divide-y divide-[#D5B98C]/40 text-sm max-h-60 overflow-y-auto" data-testid="inv-history">
        {moves.map((m) => (
          <li key={m.id} className="py-2 flex justify-between gap-3">
            <span><b className="capitalize">{m.type}</b> {m.delta > 0 ? `+${m.delta}` : m.delta} → {m.stock_after}{m.note && <span className="text-[#242321]/55"> · {m.note}</span>}</span>
            <span className="text-[11px] text-[#242321]/50 shrink-0">{new Date(m.at).toLocaleDateString("it-IT")}</span>
          </li>
        ))}
        {moves.length === 0 && <li className="py-2 text-[#242321]/55">Nessun movimento.</li>}
      </ul>
    </Panel>
  );
};
